module.exports = __webpack_public_path__ + "h5/img/hotTitle.2f9a5771.png";